import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ChangePassword from "@/pages/ChangePassword";
import Dashboard from "@/pages/Dashboard";
import ContractsList from "@/pages/ContractsList";
import ContractDetail from "@/pages/ContractDetail";
import NewContract from "@/pages/NewContract";
import ImportContracts from "@/pages/ImportContracts";
import Report from "@/pages/Report";
import Agenda from "@/pages/Agenda";
import Alertas from "@/pages/Alertas";
import Configuracoes from "@/pages/Configuracoes";
import ExecutiveReport from "@/pages/ExecutiveReport";
import Users from "@/pages/Users";
import Issues from "@/pages/Issues";

function Protected({ children }) {
    const { user } = useAuth();
    const location = useLocation();
    if (user === undefined) return <div className="min-h-screen flex items-center justify-center text-sm text-slate-500">Carregando…</div>;
    if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
    if (user.must_change_password && location.pathname !== "/trocar-senha") {
        return <Navigate to="/trocar-senha" replace />;
    }
    return <Layout>{children}</Layout>;
}

function ChangePasswordRoute() {
    const { user } = useAuth();
    if (user === undefined) return <div className="min-h-screen flex items-center justify-center text-sm text-slate-500">Carregando…</div>;
    if (!user) return <Navigate to="/login" replace />;
    return <ChangePassword />;
}

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/trocar-senha" element={<ChangePasswordRoute />} />
                    <Route path="/" element={<Protected><Dashboard /></Protected>} />
                    <Route path="/contratos" element={<Protected><ContractsList /></Protected>} />
                    <Route path="/contratos/novo" element={<Protected><NewContract /></Protected>} />
                    <Route path="/contratos/importar" element={<Protected><ImportContracts /></Protected>} />
                    <Route path="/contratos/:id" element={<Protected><ContractDetail /></Protected>} />
                    <Route path="/relatorios" element={<Protected><Report /></Protected>} />
                    <Route path="/issues" element={<Protected><Issues /></Protected>} />
                    <Route path="/relatorios/executivo/:cid" element={<Protected><ExecutiveReport /></Protected>} />
                    <Route path="/agenda" element={<Protected><Agenda /></Protected>} />
                    <Route path="/alertas" element={<Protected><Alertas /></Protected>} />
                    <Route path="/configuracoes" element={<Protected><Configuracoes /></Protected>} />
                    <Route path="/usuarios" element={<Protected><Users /></Protected>} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
